import {FormikSelect} from '@flexinet/ui-components';
import {usePrices} from '../hooks/usePrices.ts';
import {Price} from '../types';
import {FieldProps} from 'formik';
import {SelectProps} from '@mantine/core';


export const PricesDropdown = (props: FieldProps & SelectProps) => {

    const {items: components} = usePrices();

    const selectOptions = components.map((price: Price) => {
        return {
            value: price.id,
            label: `${price.product?.name || price.id} - $${(price.amount / 100).toFixed(2)}`,
        };
    });

    return <FormikSelect {...props} data={selectOptions}/>;
};
